import { fixSteps } from '@/mocks/home';

export default function FixSteps() {
  return (
    <section id="fix" className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="flex items-center gap-2">
          <span className="h-5 w-1 rounded-full bg-accent-500" />
          <span className="font-label text-sm tracking-[0.2em] text-accent-600">TROUBLESHOOT</span>
        </div>
        <div className="mt-3 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">网址打不开时的正确找法</h2>
          <p className="max-w-xl text-sm text-foreground-600">按顺序排查，多数「入口失效」都能在两步内解决。</p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
          {fixSteps.map((s) => (
            <article
              key={s.no}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-accent-300"
            >
              <span className="font-label text-4xl leading-none text-accent-200">{s.no}</span>
              <h3 className="mt-3 font-heading text-lg text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{s.desc}</p>
            </article>
          ))}

          <article className="flex flex-col justify-center rounded-lg border border-accent-300 bg-accent-50 p-5">
            <i className="ri-lightbulb-flash-line text-2xl text-accent-600" />
            <h3 className="mt-3 font-heading text-lg text-accent-950">一条经验</h3>
            <p className="mt-2 text-[13px] leading-relaxed text-accent-900">
              收藏本页比记住任何一个域名都可靠。入口一变，这里同步更新，随时回来核对最新地址即可。
            </p>
            <button
              type="button"
              className="mt-4 inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-[13px] font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-bookmark-line" />
              收藏本页
            </button>
          </article>
        </div>
      </div>
    </section>
  );
}